
export const dataURLtoFile = (dataurl, filename) => {
    return new File([new Blob([dataurl])], filename);
};
